// import css from "./blog.module.css";
// import hokBlog from "../HOK/hokBlog";
// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import YouTube from "react-youtube";
// import YouLikeIt from "../catalog/youLikeIt";
// import parse from "html-react-parser";
// import { domToReact } from "html-react-parser";

// const BlogPage = ({ blogData }) => {
//   const { id } = useParams();
//   const [selectedBlog, setSelectedBlog] = useState(null);

//   useEffect(() => {
//     const foundBlog = blogData.find((blog) => blog.uid === id);
//     setSelectedBlog(foundBlog);
//   }, [blogData, id]);

//   return (
//     <div className={css.blogWrapPage}>
//       {selectedBlog ? (
//         <div className={css.blogWrapPageSmall}>
//           <h1 className={css.blogWrapPageH1}>{selectedBlog.zag}</h1>
//           {/* <div className={css.wpaPicAbout}>
//             <div
//               className={css.paragInWrapBig}
//               dangerouslySetInnerHTML={{ __html: selectedBlog.longDesc }}
//             ></div>
//             <div className={css.imgAboutWrap}>
//               <img src={selectedBlog.photo} className={css.imgAbout} />
//             </div>
//           </div> */}
//           <div className={css.blogFloatTextWrap}>
//             <img
//               src={selectedBlog.photo}
//               alt=""
//               className={css.floatImageRight}
//             />

//             <div
//               className={css.paragInWrapBig}
//               dangerouslySetInnerHTML={{ __html: selectedBlog.longDesc }}
//             ></div>
//           </div>
//           {/* <p className={css.paragInWrapBig}>{selectedBlog.centrDesc}</p> */}
//           {selectedBlog.videoId.length > 1 && (
//             <div className={css.wpaPicAbout}>
//               <div className={css.imgAboutWrapYou}>
//                 <YouTube
//                   videoId={selectedBlog.videoId}
//                   className={css.youtube}
//                   opts={{ width: "100%", height: "100%" }}
//                 />
//               </div>
//             </div>
//           )}
//           {/* {selectedBlog.videoId.length < 1 && (
//             <p className={css.paragInWrapBig}>{selectedBlog.longDesc}</p>
//           )} */}
//           {/* Додаткові поля блогу
//           <YouLikeIt/>*/}
//         </div>
//       ) : (
//         <p>Завантаження блогу...</p>
//       )}
//     </div>
//   );
// };
// export default hokBlog(BlogPage);
import css from "./blog.module.css";
import hokBlog from "../HOK/hokBlog";
import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import YouTube from "react-youtube";
import {
  getBlogPath,
  getBlogSlug,
  normalizeBlogSlug,
} from "../../function/blogSlug";

const BlogPage = ({ blogData }) => {
  /*
   * Назва параметра повинна відповідати
   * маршруту /blog/:slug в App.js.
   */
  const { slug } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  /*
   * Шукаємо статтю без додаткового useState.
   *
   * selectedBlog автоматично перерахується,
   * коли зміниться blogData або slug.
   */
  const selectedBlog = useMemo(() => {
    if (!Array.isArray(blogData)) {
      return null;
    }

    /*
     * Нормалізуємо значення з адресного рядка.
     */
    const normalizedRouteSlug = normalizeBlogSlug(slug);

    return blogData.find((blog) => {
      /*
       * Основне актуальне ЧПУ статті.
       */
      const currentSlug = getBlogSlug(blog);

      if (currentSlug === normalizedRouteSlug) {
        return true;
      }

      /*
       * Попередні ЧПУ статті.
       *
       * Вони зберігаються, коли адміністратор
       * змінює адресу через редактор.
       */
      const oldSlugs = Array.isArray(blog.oldSlugs)
        ? blog.oldSlugs
            .map((oldSlug) => {
              return normalizeBlogSlug(oldSlug);
            })
            .filter(Boolean)
        : [];

      if (oldSlugs.includes(normalizedRouteSlug)) {
        return true;
      }

      /*
       * Підтримка старих URL через uid.
       */
      if (blog.uid === slug) {
        return true;
      }

      /*
       * Підтримка URL через Firestore id,
       * якщо вони десь використовувалися.
       */
      if (blog.id === slug) {
        return true;
      }

      return false;
    });
  }, [blogData, slug]);

  /*
   * Перенаправляємо зі старого URL
   * на основну актуальну адресу.
   *
   * Наприклад:
   *
   * /blog/73c17c88-old-uid
   *
   * стане:
   *
   * /blog/yak-vybraty-knyhu
   */
  useEffect(() => {
    if (!selectedBlog) {
      return;
    }

    const canonicalPath = getBlogPath(selectedBlog);

    if (canonicalPath !== "/blog" && location.pathname !== canonicalPath) {
      navigate(canonicalPath, {
        replace: true,
      });
    }
  }, [selectedBlog, location.pathname, navigate]);

  /*
   * Дані ще завантажуються.
   */
  if (!Array.isArray(blogData) || blogData.length === 0) {
    return (
      <div className={css.blogWrapPage}>
        <p>Завантаження блогу...</p>
      </div>
    );
  }

  /*
   * Дані завантажились,
   * але статті з такою адресою немає.
   */
  if (!selectedBlog) {
    return (
      <div className={css.blogWrapPage}>
        <div className={css.blogWrapPageSmall}>
          <h1 className={css.blogWrapPageH1}>Статтю не знайдено</h1>

          <p>Можливо, адресу було введено неправильно або статтю видалено.</p>
        </div>
      </div>
    );
  }

  const hasVideo =
    typeof selectedBlog.videoId === "string" &&
    selectedBlog.videoId.trim().length > 1;

  return (
    <div className={css.blogWrapPage}>
      <div className={css.blogWrapPageSmall}>
        <h1 className={css.blogWrapPageH1}>{selectedBlog.zag}</h1>

        <div className={css.blogFloatTextWrap}>
          <img
            src={selectedBlog.photo}
            alt={selectedBlog.zag || "Стаття блогу"}
            className={css.floatImageRight}
          />

          <div
            className={css.paragInWrapBig}
            dangerouslySetInnerHTML={{
              __html: selectedBlog.longDesc || "",
            }}
          />
        </div>

        {hasVideo && (
          <div className={css.wpaPicAbout}>
            <div className={css.imgAboutWrapYou}>
              <YouTube
                videoId={selectedBlog.videoId}
                className={css.youtube}
                opts={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default hokBlog(BlogPage);
